var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "tooltip-notification", on: { click: _vm.openGrid } },
        [
          _c("div", { staticClass: "tooltip-notification__img-wrapper" }, [
            _c("img", {
              staticClass: "tooltip-notification__img",
              attrs: { src: _vm.img, alt: "icon " + _vm.title },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "tooltip-notification__count",
                  {
                    "tooltip-notification__count--error":
                      this.status === "error",
                    "tooltip-notification__count--alert":
                      this.status === "alert",
                    "tooltip-notification__count--oke":
                      this.status === "oke" || _vm.count === 0,
                  },
                ],
              },
              [this.count ? _c("span", [_vm._v(_vm._s(this.count))]) : _vm._e()]
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.title))]),
        ]
      ),
      _vm._v(" "),
      _vm.showModal === _vm.id
        ? _c("Modal", {
            attrs: { title: _vm.title, id: _vm.id },
            on: { close: _vm.closeModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }